import React, { ReactNode } from 'react';
import '../styles/ContactForm.css';

interface FormRowProps {
  children: ReactNode;
  columns?: 2 | 3;
}

const FormRow: React.FC<FormRowProps> = ({ children, columns = 2 }) => {
  return (
    <div className={`form-row form-row-${columns}`}>
      {children}
    </div>
  );
};

export default FormRow;

